import { Navigate } from "react-router-dom"
import { ReactNode } from "react"
import ROUTE_PATHS from "./route-path"

const PrivateRoute = ({ children }: { children: ReactNode }) => {
  const token = localStorage.getItem("token")
  return token ? children : <Navigate to={ROUTE_PATHS.LOGIN} />
}

export default PrivateRoute
